import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ContentWithCardLoading } from "../../../../components/loading";
import AdvanceDataTable from "../../../../components/normal-table/advance-table";
import ContentWrapper from "../../../Wrapper";
import GatewayAndPriceSubheader from "../../components/gateway-and-price-subheader";
import * as gatewayAndPriceEmailActions from "../../store/actions/gateway_and_price_list_email_actions";

export default function GatewayAndPriceListEmail() {
  const tabName = "Email Pricing";
  const gatewayAndPriceListSms = useSelector((state) => state.gatewayAndPrice.gatewayAndPriceListEmail);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(gatewayAndPriceEmailActions.getListOfGatewayAndPriceEmailRequest());
  }, [dispatch]);

  return (
    <ContentWrapper subHeader={<GatewayAndPriceSubheader tabName={tabName} />}>
      {gatewayAndPriceListSms.loading ? (
        <ContentWithCardLoading />
      ) : gatewayAndPriceListSms.data.length === 0 ? (
        "No accounts"
      ) : (
        <div className={`card card-custom`}>
          <div className="card-body py-3 px-3" style={{ padding: 15 }}>
            <AdvanceDataTable
              columns={[
                { title: "Currency", apiKeyName: "currency", fieldInputType: "INPUT" },
                { title: "Price", apiKeyName: "price", fieldInputType: "INPUT" },
                { title: "Attachment Price", apiKeyName: "attachmentPrice", fieldInputType: "INPUT" },
              ]}
              data={gatewayAndPriceListSms.data}
              limit={10}
              pageNo={1}
              count={2}
            />
          </div>
        </div>
      )}
    </ContentWrapper>
  );
}
